//Please add the language resource
const orderReceiptLog = {
  serialNo: 'serialNo',
  orderNo: 'orderNo',
  dealStatus: 'dealStatus',
  dealCount: 'dealCount',
  dealTime: 'dealTime',
  dealResult: 'dealResult',
  createTime: 'createTime',
  imageUrl: 'imageUrl',
  msg: {}
};
export default orderReceiptLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/orderReceiptLog/lang/orderReceiptLog.en.js